module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-175479256-1","head":true,"respectDNT":true,"exclude":["/cat/**","/test/"]},
    }]
